/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */

/**
 * The loading component for Chart
 *
 * @author Yakov Gushchin
 * @author Maxim Fedorov
 * @author Anton Panasenko
 * @version 1.3.0
 * @since 1.1.0
 */

import { FC } from 'react';

import { Loader } from '../../../modules/loader/components/Loader';
import BizCharts from './BizchartsLoadable';
import { ChartCategoryStyled } from './ChartsImplementation/ChartCategory/styled/ChartCategotyStyled';
import { getChartImplementation } from './ChartsImplementation/chartImplementation';
import { EChartImplementationType, IChartImplementation } from './ChartsImplementation/chartImplementationTypes';
import {
    EChartDataKeyEnum,
    IChartLabels,
    TMapNameToColor,
    TMapNameToTranslation,
} from './chartTypes';
import { ChartLoaderContainerStyled, ChartLoaderStyled } from './styled/ChartLoadingStyled';

export interface IChartLoadingProps {
    mapIdToLabel: IChartLabels;
    mapNameToColor: TMapNameToColor;
    mapNameToTranslation: TMapNameToTranslation;
    type: EChartImplementationType;
    width: number;
}

export const ChartLoading: FC<IChartLoadingProps> = props => {

    const chartImplementation: IChartImplementation = getChartImplementation(props.type);
    const scale = chartImplementation.scale;

    return (
        <BizCharts fallback={<Loader showLoader={true}/>}>
            {({ Chart, Axis, Geom }) => (
                <ChartCategoryStyled>

                    <ChartLoaderContainerStyled>
                        <ChartLoaderStyled/>
                    </ChartLoaderContainerStyled>

                    <Chart
                        data={chartImplementation.loading.chartData}
                        height={chartImplementation.loading.height}
                        padding={chartImplementation.padding}
                        scale={scale}
                        width={props.width}
                    >
                        <Axis
                            grid={chartImplementation.grid.y}
                            name={EChartDataKeyEnum.y}
                        />

                        <Axis
                            grid={chartImplementation.grid.x}
                            label={({ htmlTemplate: () => '' })}
                            name={EChartDataKeyEnum.x}
                        />

                        <Geom
                            color="transparent"
                            opacity={1}
                            position={`${EChartDataKeyEnum.x}*${EChartDataKeyEnum.y}`}
                            type={chartImplementation.type}
                        />
                    </Chart>

                </ChartCategoryStyled>
                )
            }
        </BizCharts>
    );
};

export default ChartLoading;
